import axios from 'axios'
import { MaximizeIcon } from 'vue-feather-icons'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

import ModalMixin from '@/mixins/ModalMixin.js'
import CreateOption from '@/mixins/CreateOption.js'
import TransformOptions from '@/mixins/TransformOptions.js'
import OpenBoxMixin from '@/mixins/OpenBoxMixin.js'

import BarcodeAndQrModal from '@/vcs/_shared/modals/BarcodeAndQrModal.vue'
import PhysicalQrReaderModal from '@/vcs/_shared/modals/PhysicalQrReaderModal.vue'
import CloseLockerPromptModal from '@/vcs/_shared/modals/CloseLockerPromptModal.vue'
import ChooseBoxModal from '@/vcs/_shared/modals/ChooseBoxModal.vue'
import SenderInfo from './sender-info/cmp.vue'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  name: 'DeliveryRequestUpdate',
  components: { MaximizeIcon, vSelect, SenderInfo, PhysicalQrReaderModal },
  mixins: [ModalMixin, CreateOption, TransformOptions, OpenBoxMixin],
  data: function () {
    return {
      CloseLockerPromptModal,

      courierCompanyName: '', // needed in request
      deliveryComment: '', // needed in request
      user: null,
      isFooterTop: false,

      showWarningBorder: false,
      showWarningBorderForDescription: false,
      deliveryCommentRows: [
        {
          content: ''
        }
      ]
    }
  },
  watch: {
    deliveryCommentRows: {
      deep: true,
      handler: function () {
        eventBus.$emit('refresh-token-via-websockets')
      }
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp',
      deviceId: 'getDeviceId'
    }),
    courierCompanyNameIsEmail() {
      return (
        this.courierCompanyName.includes('@') && this.courierCompanyName.includes('.')
      )
    }
  },
  mounted() {
    eventBus.$emit('refresh-token-via-websockets')
  },
  methods: {
    companyNameChangedHandler(companyName) {
      this.courierCompanyName = companyName
    },
    userChangedHandler(user) {
      this.user = user
    },
    updateDR() {
      if (!this.courierCompanyName && !this.user) {
        this.$errorHumanized(null, this.$t('error.courierNameRequired'))
        this.showWarningBorder = true
        return
      }

      if (this.cp.isDeliveryCommentRequired && !this.deliveryComment) {
        this.$errorHumanized(null, this.$t('error.commentRequired'))
        this.showWarningBorderForDescription = true
        return
      }

      let token = window.localStorage.getItem('delivery_request_token')
      this.$blockUI()
      axios({
        method: 'put',
        url: `/delivery_requests/${this.$route.params.id}/fill_data`,
        headers: {
          common: {
            Authorization: `Bearer ${token}`
          }
        },
        params: {
          'delivery_request[courier_company_name]': this.courierCompanyName,
          'delivery_request[delivery_comment]': this.deliveryComment,
          'delivery_request[sender_id]': this.user?.id
        }
      })
        .then((response) => {
          console.log('updateDR response', response)

          if (this.cp.pickableSizeEnabled) {
            this.$unblockUI()
            this.openSelectBoxSizeModal()
          } else {
            // blocker is continiued here:
            this.openBoxMixinFn(response.data.id, token)
          }
        })
        .catch((error) => {
          this.$errorHumanized(error)
          this.$unblockUI()
        })
      // TODO: Wszystkie this.$unblockUI(); przeniesc do finally
    },
    openSelectBoxSizeModal() {
      this.$store.commit('modal/open', {
        cmp: ChooseBoxModal,
        size: 'full',
        callback: this.redirectToConfirmation
      })
    },
    redirectToConfirmation(obj) {
      this.$router.push(
        `/delivery/delivery-request/${this.$route.params.id}/confirmation`
      )
    },
    openBarcodeAndQrModal(index) {
      this.$store.commit('modal/open', {
        cmp: BarcodeAndQrModal,
        size: 'full',
        disableRedirect: true,
        callback: (data) => {
          this.processQrData(data, index)
        }
      })
    },
    openPhysicalQrReaderModal(index) {
      this.$store.commit('modal/open', {
        cmp: PhysicalQrReaderModal,
        size: 'popup slightly-higher',
        disableRedirect: true,
        callback: (data) => {
          this.processQrData(data, index)
        }
      })
    },
    processQrData(data, index) {
      // this.deliveryComment = data;
      this.deliveryCommentRows[index].content = data
      this.updateDeliveryCommentField()
    },
    userSelected(data) {
      if (this.isCreatedOption(data)) {
        let courierCompanyName = data.itemData
        this.courierCompanyName = courierCompanyName
      } else if (this.isUser(data)) {
        let { name, phone, email, phonePrefix } = data
        let message = ''

        if (name && phone && email) {
          message = `${name} (+${phonePrefix || '48'} ${phone} | ${email})`
        } else if (phone && email) {
          message = `+${phonePrefix || '48'} ${phone} | ${email}`
        } else if (name && email) {
          message = `${name} (${email})`
        } else if (email) {
          message = email
        }
        this.courierCompanyName = message
      } else {
        this.courierCompanyName = ''
      }
    },
    focused() {
      this.showWarningBorder = false
      this.showWarningBorderForDescription = false
      this.isFooterTop = true
      this.$slideUp()
    },
    blurred() {
      this.$slideDown()
      this.isFooterTop = false
    },
    isUser(user) {
      return (user || {}).id
    },
    isCreatedOption(user) {
      return (user || {}).itemData && !(user || {}).id
    },
    addDeliveryCommentRow() {
      this.deliveryCommentRows.push({
        content: ''
      })
    },
    removeDeliveryCommentRow(index) {
      this.deliveryCommentRows.splice(index, 1)
      this.updateDeliveryCommentField()
    },
    updateDeliveryCommentField() {
      this.deliveryComment = this.deliveryCommentRows
        .map((row) => {
          return row.content
        })
        .join(';')
    }
  }
}
